//dependencias
import React, { Component } from 'react';

//componentes
import DosificacionEva from './dosificacionEva'

class Index extends Component {

    render(){
        return(
            <div>
                <DosificacionEva />
            </div>
        );
    }

}
export default Index;